module.exports = __webpack_public_path__ + "static/miniature1.cd6ce8ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/miniature1.png
// module id = 163
// module chunks = 35783957827783 267625579013595